import React, { useMemo, useState } from "react";
import Filters from "../../components/filter/Filter";
import Table from "../components/dashboard/purchases/Table";

const AdminPurchases = () => {
  return (
    <div className="flex flex-col space-y-10">
      <section>
        <Filters />
      </section>
      <section>
        <Table />
      </section>
    </div>
  );
};

export default AdminPurchases;
